import { api } from "../../lib/api";
export const getAssetFaultsSearch = async (requestBody, xCatApiTrackingId, sortBy, orderBy, limit = 20, skip, cursor) => {
    const config = {
        params: {
            ...(xCatApiTrackingId && { xCatApiTrackingId }),
            ...(sortBy && { sortBy }),
            ...(orderBy && { orderBy }),
            ...(limit && { limit }),
            ...(skip && { skip }),
            ...(cursor && { cursor })
        }
    };
    const queryParams = new URLSearchParams(config.params).toString(); // Convert params to query string
    const { data } = await api.post(`/assets/faults/search${queryParams && "?" + queryParams}`, requestBody);
    return data; // return the data if the API call succeeds
};
export const getAssetFaultsCount = async (xCatApiTrackingId, requestBody) => {
    const config = {
        params: {
            ...(xCatApiTrackingId && { xCatApiTrackingId })
        }
    };
    const queryParams = new URLSearchParams(config.params).toString(); // Convert params to query string
    const { data } = await api.post(`/assets/faults/COUNT${queryParams && "?" + queryParams}`, requestBody);
    return data; // return the data if the API call succeeds
};
